export default "__VITE_ASSET__a00f6fbb__"